<template>
    <tw-row>
        <tw-col :xs_span="xs_span" :sm_span="sm_span" :md_span="md_span" :lg_span="lg_span" :xl_span="xl_span" v-for="column in columns" :key="column.field_name">
            <tw-form-item :label="column.caption" label_width="80px" :allow_null="column.allow_null" :edit_width="column.edit_width ? `${column.edit_width}px` : '100%'">
                <tw-cell-edit :column="column" :dataRow="current_row" :readonly="readonly" @btnClick="btnClick"></tw-cell-edit>
            </tw-form-item>
        </tw-col>
    </tw-row>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'tw-form-view',
    setup(props, context) {
        const columns = computed(() => {
            return props.data_source && props.data_source.columns && props.data_source.columns.filter(el => {
                let visible = true
                // 需要注意如果无 visible 时也要显示，只有等于 False 时才不显示
                if (el.visible === false) {
                    visible = false
                } else {
                    // 如果指定分组，则只显示该分组的字段
                    if (props.group_name) {
                        visible = el.group_name === props.group_name
                    }
                }

                return visible
            }) || []
        })

        const current_row = computed({
            get() {
                if (props.data_source && Array.isArray(props.data_source.datas) && props.data_source.datas.length) {
                    return props.data_source.datas[0]
                } else {
                    return {}
                }
            },
            set(value){
                if(value){
                    // eslint-disable-next-line vue/no-mutating-props
                    props.data_source.current = value
                }
            }
        })

        // 来自tw-cell-edit扩展按钮点击事件
        const btnClick = (obj) => {
            context.emit('btnClick', obj)
        }

        return {
            columns,
            current_row,
            btnClick
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        group_name: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        // <768px 响应式栅格数
        xs_span: {
            type: Number,
            default: 12
        },
        // ≥768px 响应式栅格数
        sm_span: {
            type: Number,
            default: 12
        },
        // ≥992px 响应式栅格数
        md_span: {
            type: Number,
            default: 6
        },
        // ≥992px 响应式栅格数
        lg_span: {
            type: Number,
            default: 4
        },
        // ≥1920px 响应式栅格数
        xl_span: {
            type: Number,
            default: 3
        }
    }
}
</script>